export default __webpack_public_path__ + "static/media/logo-algo-icon.2b812f73.png";